export default __webpack_public_path__ + "static/media/PlusCircle.31b901a0.svg";